// Hooks that must run before a site's app boots. agent.js runs them the moment it loads, which
// is before the app's own (module) scripts when its tag sits above them in <head>.
import installMidiHook from '../sites/midi-designer/debug-hook.js';

const MIDI_RESTORE = 'bcagent:midi-restore'; // set by the MIDI adapter before a reload with ?debug

function midi() {
  let restore = null;
  try {
    restore = sessionStorage.getItem(MIDI_RESTORE);
    sessionStorage.removeItem(MIDI_RESTORE);
  } catch {
    /* no storage: the hook below still runs */
  }
  if (restore && restore.startsWith(location.origin + '/') && new URL(location.href).searchParams.has('debug')) {
    // The adapter reloaded with ?debug because the hook came too late (the script tag was
    // async or below the app). The app sees the flag itself; put the address back once it has
    // published its internals, as the hook does.
    const t0 = Date.now();
    const timer = setInterval(() => {
      if (!window.__md && Date.now() - t0 < 15000) return;
      clearInterval(timer);
      try {
        history.replaceState(history.state, '', restore);
      } catch {
        /* ignore */
      }
    }, 100);
    return;
  }
  installMidiHook();
}

export function runEarlyHooks(entry) {
  if (entry?.early === 'midi') midi();
}
